import RequiredAttachmentsBackgroundSetup from "./RequiredAttachmentsBackgroundSetup";

export default RequiredAttachmentsBackgroundSetup;
